import { AccordionDetails, List, ListItem, styled } from "@mui/material";

export const Styled = {
    OrderedList: styled(List)`
        list-style: decimal;
        margin-left: 16px;
    `,
    UnorderedList: styled(List)`
        list-style: decimal;
        margin-left: 16px;
    `,
    Bold: styled("span")`
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
    `,
    AccordionDetails: styled(AccordionDetails)`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
    ListItem: styled(ListItem)`
        display: list-item;
        padding: 0;
    `,
};
